<app-create-export-form [configs]="configs$ | async" [formModel]="formModel" [skipFirstStep]="skipFirstStep"
    (createExport)="createExport($event)"></app-create-export-form>